import React, { Component } from 'react'
import { Layout, About, Login } from 'components'
import { Router, Route } from 'react-router-dom'
import Home from 'components/Home'
import Funds from 'components/Funds'
import Theme from 'components/Theme'
import Status from 'components/Status'
import Admin from 'components/Admin'
import history from 'utils/history'

class Routes extends Component {
  render() {
    return (
      <Router history={history}>
        <Theme>
          <Layout>
            <Route exact path="/index.html" component={Home} />
            <Route exact path="/" component={Home} />
            <Route path="/login" component={Login} />
            <Route path="/funds" component={Funds} />
            <Route path="/about" component={About} />
            <Route path="/status" component={Status} />
            <Route path="/admin" component={Admin} />
          </Layout>
        </Theme>
      </Router>
    )
  }
}

export default Routes



// WEBPACK FOOTER //
// ./src/routes/index.js